import styled from 'styled-components'

export const TitleInformationContainer = styled.div`
  width: 208px;
  height: 24px;
  margin: 44px 169px 24px 0px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  color:#000000;
`